import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ToastContainer } from "react-toastify-redux";


// Routes
import Routes from './routes';
import Services from './services/Services';
import ServicesProvider from './components/ServicesProvider';

import store from './redux/store';

interface IContext {
  services: object,
  store: object,
}

class Root extends React.Component<{}, {}> {
  public context: IContext = { services: {}, store: {} };
  private services: object;
  private store: object;

  constructor(props) {
    super(props);

    const { context } = this;
    context.services = new Services(context);
    context.store = store;

    this.services = context.services;
    this.store = context.store;
  }

  public render() {
    return (
      <Provider store={store}>
        <ToastContainer/>
        <ServicesProvider services={this.services}>
          <Routes />
        </ServicesProvider>
      </Provider>
    );
  }
}

ReactDOM.render(<Root />, document.getElementById('root'));

export default store



// WEBPACK FOOTER //
// ./src/index.tsx